module.exports = __webpack_public_path__ + "img/patient-exp.ed098e65.svg";